<template>
  <div>
    <div class="page-title-header">
      <div class="page-header">
        <b-breadcrumb class="m-0">
          <b-breadcrumb-item
            :to="{
              name: 'DashboardHome',
            }"
          >
            <i class="fa fa-home"></i>
          </b-breadcrumb-item>
          <b-breadcrumb-item active>全系統設定</b-breadcrumb-item>
          <b-breadcrumb-item :to="{
              name: 'OrganizationModuleList',
              params: {table: table}
            }">
            全模組列表
          </b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'OrganizationModuleChildrenList', params: { parent_id: parent_id, table: table } }">
            <template v-if="parent">【{{ parent.name }}】</template>全模組列表
          </b-breadcrumb-item>
          <b-breadcrumb-item active>{{ isReadOnly ? "檢視模組" : isEditing ? '編輯模組' : '新增模組' }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>

    <b-card>
      <b-overlay :show="showLoading">
        <h4 class="mb-3 font-weight-bold">{{ isReadOnly ? "檢視模組" : isEditing ? '編輯模組' : '新增模組' }}</h4>
        <div class="mb-2">
          <validation-error-alert
            v-if="validationErrors"
            :errors="validationErrors"
          ></validation-error-alert>
          <!-- 設定類型 Start -->
          <b-form-group
            label-cols="12"
            label-cols-lg="2"
            label-size="sm"
            label="設定類型"
            label-for="merchant"
          >
            <b-form-select
              v-model="form.table"
              :options="tableOptions"
              :disabled="isReadOnly"
            ></b-form-select>
            <b-form-invalid-feedback :state="!deepGet(v$, 'form.table.$error')">
              此欄位為必填
            </b-form-invalid-feedback>
          </b-form-group>
          <!-- 設定類型 End -->

          <!-- 代碼 Start -->
          <b-form-group
            label-cols="12"
            label-cols-lg="2"
            label-size="sm"
            label="代碼"
          >
            <b-form-input
              type="text"
              :state="deepGet(v$, 'form.key.$error') ? false : null"
              v-model="form.key"
              :readonly="isReadOnly"
            ></b-form-input>
            <b-form-invalid-feedback :state="!deepGet(v$, 'form.key.$error')">
              此欄位為必填
            </b-form-invalid-feedback>
          </b-form-group>
          <!-- 代碼 End -->

          <!-- 資料類型 Start -->
          <b-form-group
            label-cols="12"
            label-cols-lg="2"
            label-size="sm"
            label="資料類型"
          >
            <b-form-select
              v-model="form.type"
              :options="typeOptions"
              :disabled="isReadOnly"
            ></b-form-select>
          </b-form-group>
          <!-- 資料類型 End -->

          <!-- 分類 Start -->
          <b-form-group
            label-cols="12"
            label-cols-lg="2"
            label-size="sm"
            label="分類"
          >
            <b-form-input
              type="text"
              :state="deepGet(v$, 'form.category.$error') ? false : null"
              v-model="form.category"
              :readonly="isReadOnly"
            ></b-form-input>
          </b-form-group>
          <!-- 分類 End -->

          <!-- 名稱 Start -->
          <b-form-group
            label-cols="12"
            label-cols-lg="2"
            label-size="sm"
            label="名稱"
          >
            <b-form-input
              type="text"
              :state="deepGet(v$, 'form.name.$error') ? false : null"
              v-model="form.name"
              :readonly="isReadOnly"
            ></b-form-input>
            <b-form-invalid-feedback :state="!deepGet(v$, 'form.name.$error')">
              此欄位為必填
            </b-form-invalid-feedback>
          </b-form-group>
          <!-- 名稱 End -->

          <!-- 內容描述 Start -->
          <b-form-group
            label-cols="12"
            label-cols-lg="2"
            label-size="sm"
            label="內容描述"
          >
            <b-form-textarea
              class="mb-2 mr-sm-2 mb-sm-0"
              v-model="form.description"
              rows="5"
              :readonly="isReadOnly"
            ></b-form-textarea>
          </b-form-group>
          <!-- 內容描述 End -->

          <!-- 系統方案代碼 Start -->
          <b-form-group
            label-cols="12"
            label-cols-lg="2"
            label-size="sm"
            label="系統方案代碼"
          >
            <b-form-input
              type="text"
              :state="deepGet(v$, 'form.target.$error') ? false : null"
              v-model="form.target"
              :readonly="isReadOnly"
            ></b-form-input>
          </b-form-group>
          <!-- 系統方案代碼 End -->

          <!-- 內容 Start -->
          <b-form-group
            label-cols="12"
            label-cols-lg="2"
            label-size="sm"
            label="內容"
          >
            <JsonEditor
              height="64px"
              v-model="form.content"
            ></JsonEditor>
          </b-form-group>
          <!-- 內容 End -->

          <!-- 設定檔 Start -->
          <b-form-group
            label-cols="12"
            label-cols-lg="2"
            label-size="sm"
            label="設定檔"
          >
            <JsonEditor
              height="64px"
              v-model="form.config"
            ></JsonEditor>
          </b-form-group>
          <!-- 設定檔 End -->

          <!-- 順序 Start -->
          <b-form-group
            label-cols="12"
            label-cols-lg="2"
            label-size="sm"
            label="順序"
          >
            <b-form-input
              type="text"
              :state="deepGet(v$, 'form.order.$error') ? false : null"
              v-model="form.order"
              :readonly="isReadOnly"
            ></b-form-input>
            <b-form-invalid-feedback :state="!deepGet(v$, 'form.order.$error')">
              此欄位為必填
            </b-form-invalid-feedback>
          </b-form-group>
          <!-- 順序 End -->
        </div>
        <!-- 欄位部分 End -->
        <!-- 表單底部 Start -->
        <div class="d-flex justify-content-center">
          <b-button
            class="mr-3"
            @click="cancel"
            variant="outline-danger"
          >
            返回
          </b-button>
          <b-button
            @click="submit"
            variant="success"
            v-if="!isReadOnly"
          >
            儲存
          </b-button>
        </div>
        <!-- 表單底部 End -->
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Datepicker from "vuejs-datepicker";
import { zh } from "vuejs-datepicker/dist/locale";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import AppFileUploader from "@/components/AppFileUploader.vue";
import TrixEditor from "@/components/TrixEditor";
import deepGet from "@/utils/deepGet";
import mergeDefaultAndDataModel from "@/utils/mergeDefaultAndDataModel";
import AppSingleSelect from "@/components/AppSingleSelect.vue";
import PermissionChecker from "@/utils/PermissionChecker";
import {organizationModuleChildrenApi, organizationModuleApi} from "@/apis/organization-module";
import JsonEditor from "@/components/Dashboard/JsonEditor.vue";

export default {
  components: {
    JsonEditor,
    AppSingleSelect,
    Datepicker,
    AppFileUploader,
    TrixEditor,
  },
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return {
      form: {
        table : { required },
        name  : { required },
        key   : { required },
        order : { required }
      },
    };
  },
  data() {
    return {
      zh,
      showLoading: true,
      form: {
        table: null,
        category: null,
        config: null,
        content: null,
        description:null,
        key: null,
        name: null,
        order: null,
        target: null,
        type: null,
      },
      selected_table: {},
      validationErrors: null,
      parent_id: null,
      table: null,
      parent: null,
    };
  },
  computed: {
    ...mapGetters('general', [
      'myBranches',
      'currentBranch'
    ]),
    ...mapGetters("route", ["routeQuery"]),
    ...mapState("general", ['defaultMerchantType', 'organization']),
    id() {
      return this.$route.params.organization_module_id;
    },
    isEditing() {
      return !!this.id;
    },
    isReadOnly() {
      return this.$route.name === "OrganizationModuleChildrenView";
    },
    tableOptions() {
      return [
        {
          value: "default",
          text: "請選擇設定類型",
        },
        {
          value: "modules",
          text: "模組",
        },
        {
          value: "organization_variables",
          text: "組織參數",
        },
        {
          value: "templates",
          text: "通知樣板",
        },
        {
          value: "chatbot_keywords",
          text: "關鍵字  ",
        },
      ];
    },
    typeOptions() {
      return [
        {
          value: "string",
          text: "string",
        },
        {
          value: "number",
          text: "number",
        },
        {
          value: "boolean",
          text: "boolean",
        },
        {
          value: "json",
          text: "json",
        },
        {
          value: "array",
          text: "array",
        },
        {
          value: "file",
          text: "file",
        },
        {
          value: "color",
          text: "color",
        },
        {
          value: "html",
          text: "html",
        },
        {
          value: "module",
          text: "module",
        },
      ]
    }
  },
  async mounted() {
    this.parent_id = this.$route.params.parent_id;
    this.table     = this.$route.params.table;

    try {
      if (this.id) {
        await this.fetchOrganizationModule();
      }

      if (this.parent_id) {
        const { data } = await organizationModuleApi.get(this.parent_id);
        this.parent = data.data;
      }
    } catch (e) {
      console.error(e)
      this.$swal("錯誤", "讀取資料錯誤", "error");
      this.$router.replace({name: "OrganizationModuleChildrenList", params: { parent_id: this.parent_id,table: this.table}, query: this.routeQuery});
    }

    if (!this.isEditing) {
      this.form.branch_id = this.selected_table.value;
    }

    this.showLoading = false;
  },
  methods: {
    deepGet,
    mergeDefaultAndDataModel,
    checkPermission(permissions) {
      const checker = new PermissionChecker();
      return checker.check(permissions);
    },
    cancel() {
      this.$router.push({ name: 'OrganizationModuleChildrenList', params: {parent_id: this.parent_id, table: this.table}, query: this.routeQuery });
    },
    async fetchOrganizationModule() {
      const { data } = await organizationModuleChildrenApi.get(this.parent_id, this.id);

      let form = this.mergeDefaultAndDataModel(this.form, data.data);
      this.$set(this, 'form', form);
    },
    async submit() {
      const result = await this.v$.$validate();
      if (!result) return false;

      try {
        this.showLoading = true;

        if (this.isEditing) {
          const response = await organizationModuleChildrenApi.update(this.parent_id, {
            id: this.id,
            ...this.form,
          });

          if (response.status && response.status === 200) {
            this.$swal.fire({
              title: "更新成功",
              type: "success",
            });
          }
        } else {
          const response = await organizationModuleChildrenApi.store(this.parent_id, {
            ...this.form,
          });

          if (response.status && response.status >= 200) {
            this.$swal.fire({
              title: "新增成功",
              type: "success",
            });
          }
        }

        this.$router.push({ name: 'OrganizationModuleChildrenList', params: { parent_id: this.parent_id, table: this.table}, query: this.routeQuery });
      } catch (error) {
        this.showLoading = false;

        if (error.response.status === 422 && error.response.data.message) {
          this.validationErrors = error.response.data.message;
          return
        }

        this.$swal.fire({
          type: "error",
          title: this.isEditing ? "更新失敗" : "新增失敗",
          text: error.response.data?.message || "請稍後再試",
        });
      }
    },
  },
};
</script>
